import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FirebaseService } from './firebase.service';

@Injectable({
  providedIn: 'root'
})
export class EsercenteAuthGuard implements CanActivate {

  constructor(private router: Router,
              private fbService: FirebaseService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    this.fbService.previousUrl = state.url;
    const loggedIn = this.fbService.isLoggedIn();
    if (!loggedIn) {
      this.router.navigateByUrl("/auth/login");
    }
    return loggedIn;
  }
}
